var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListGoldDotsBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "list-gold-dots-bg",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    fill: "#005F74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListGoldDotsBg);
export default __webpack_public_path__ + "static/media/list-gold-dots-bg.1657088dcad37f47c8b790e6fa1f1b36.svg";
export { ForwardRef as ReactComponent };